import { FC, Fragment } from 'react'
import { Menu, MenuButton, MenuItem, MenuItems, Transition } from '@headlessui/react'

import { Icon } from '~/src/components/generic/PhosphorIcons'

import { ActionEnum, ItemMenu } from '~/src/components/shared/NavBar/types'

import { tw } from '~/lib/utils'
import colors from '~/config/colorsScheme'

const OPTIONS: Array<ItemMenu> = [
  {
    iconName: 'FileXIcon',
    label: 'Report an issue',
    action: ActionEnum.ReportIssue,
  },
  {
    iconName: 'GearSixIcon',
    label: 'Settings',
    action: ActionEnum.Settings,
  },
  {
    iconName: 'SignOutIcon',
    label: 'Log out',
    action: ActionEnum.Logout,
  },
]

type Props = {
  onOptionSelect: (option: ActionEnum) => void
}

const MobileSettingsMenu: FC<Props> = ({ onOptionSelect }) => {
  return (
    <>
      <Menu as="div" className="relative inline-block text-left">
        <MenuButton aria-label="Open settings" className="w-8 pl-2 pt-2">
          <Icon color={colors.gray[700]} name="CaretDownIcon" size="18" weight="fill" />
        </MenuButton>
        <Transition
          as={Fragment}
          enter="transition ease-out duration-100"
          enterFrom="transform opacity-0 scale-95"
          enterTo="transform opacity-100 scale-100"
          leave="transition ease-in duration-75"
          leaveFrom="transform opacity-100 scale-100"
          leaveTo="transform opacity-0 scale-95"
        >
          <MenuItems className="absolute right-0 z-[999] mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black/5 focus:outline-none">
            <div className="px-1 py-1">
              {OPTIONS.map(({ iconName, label, action }, idx) => (
                <MenuItem key={idx}>
                  {({ focus }) => (
                    <button
                      className={tw(
                        focus ? 'bg-blue-50' : 'text-default',
                        'flex w-full items-center space-x-2 rounded-md p-2 text-body-s-emphasized'
                      )}
                      onClick={() => onOptionSelect(action)}
                    >
                      <Icon color={colors.gray[700]} name={iconName} size="24" />
                      <div>{label}</div>
                    </button>
                  )}
                </MenuItem>
              ))}
            </div>
          </MenuItems>
        </Transition>
      </Menu>
    </>
  )
}

export default MobileSettingsMenu
